export default __webpack_public_path__ + "static/media/Algo.5e41f5d3.webp";